(function (global, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // If supports for AMD is available return the value to the AMD Loader
    // and to the global (window) object in case any JS module is expecting
    // the homeStatusList to exists on the window object.
    define('homeStatusList',[], () => factory(global));
  } else if (typeof exports === 'object') {
    // If supports for Common JS is available export the module
    // and pass is value to the global (window) object in case non Common JS code
    // is expected to work with this homeStatusList.
    module.exports = factory(global);
  } else {
    // If not support for AMD or Common JS is available register the module in the global scope.
    factory(global);
  }
}(
  typeof window !== 'undefined' ? window : {},
  (global) => {
    'use strict';

    global.NewHomeSource = global.NewHomeSource || {};

    const previousHomeStatusList = global.NewHomeSource.HomeStatusList;

    const HomeStatus = {
      Floorplans: 'R',
      Inventory: 'UC,A',
      Model: 'M',
      HotDeals: 'H'
    };

    /**
      * @constructs NewHomeSource.HomeStatusList
    */
    function HomeStatusList() {
    }

    HomeStatusList.getAmenitiesFromHomeStatus = function getAmenitiesFromHomeStatus(value) {
      const homeStatusList = {};
      Object.keys(HomeStatus).forEach((status) => {
        let statusValue = false;

        if (value && value.indexOf(HomeStatus[status]) >= 0) {
          statusValue = true;
        }
        homeStatusList[status] = statusValue;
      });

      return homeStatusList;
    };

    /**
     * @public
     *
     * getHomeStatus: returns an array of Home Status that are contained in the value parameter.
     * @param {string} value comma separated list of Home Status identificators.
     * @returns an array with the name of all the Home Status that were provided in the value parameter.
     */
    HomeStatusList.getHomeStatus = function getHomeStatusFromValue(value) {
      if (!value || typeof value !== 'string') {
        return [];
      }

      const valueArray = value.toLowerCase().split(',');
      const keyName = [];

      valueArray.forEach((element) => {
        const status = Object.keys(HomeStatus).find((key) => HomeStatus[key].toLowerCase().indexOf(element) >= 0);

        if (keyName.indexOf(status) < 0) {
          keyName.push(status);
        }
      });

      return keyName || [];
    };

    /**
    * @public
    *
    * noConflict: Returns control of NewHomeSource.HomeStatusList to the previous script.
    */
    HomeStatusList.noConflict = function noConflict() {
      global.NewHomeSource.HomeStatusList = previousHomeStatusList;
      return HomeStatusList;
    };

    global.NewHomeSource.HomeStatusList = HomeStatusList;

    return HomeStatusList;
  }
));

